module.exports = {
  NODE_ENV: '"production"',
  //API_ROOT: '"http://medicineresearch.ngrok.wiseltd.net:9003"',
  API_ROOT: '"http://medicine.wiseltd.net:8005"',
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 194
// module chunks = 77